"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var react_1 = tslib_1.__importDefault(require("react"));
var inline_icon_1 = tslib_1.__importDefault(require("../../../ui-components/inline-icon/inline-icon"));
var ChatBigIcon_1 = tslib_1.__importDefault(require("../../../../icons/compiled/components/ChatBigIcon"));
var ChatSmallIcon_1 = tslib_1.__importDefault(require("../../../../icons/compiled/components/ChatSmallIcon"));
var DollarIcon_1 = tslib_1.__importDefault(require("../../../../icons/compiled/components/DollarIcon"));
var FilmIcon_1 = tslib_1.__importDefault(require("../../../../icons/compiled/components/FilmIcon"));
var InfoIcon_1 = tslib_1.__importDefault(require("../../../../icons/compiled/components/InfoIcon"));
var ShareIcon_1 = tslib_1.__importDefault(require("../../../../icons/compiled/components/ShareIcon"));
var SparkIcon_1 = tslib_1.__importDefault(require("../../../../icons/compiled/components/SparkIcon"));
var TimerIcon_1 = tslib_1.__importDefault(require("../../../../icons/compiled/components/TimerIcon"));
//@ts-ignore
var action_button_icon_scss_includeInitial_1 = tslib_1.__importDefault(require("./action-button-icon.scss?includeInitial"));
var withStyles_1 = require("../../../utils/withStyles");
var ACTION_BUTTON_ICONS = {
    share: ShareIcon_1.default,
    dollar: DollarIcon_1.default,
    film: FilmIcon_1.default,
    info: InfoIcon_1.default,
    spark: SparkIcon_1.default,
    timer: TimerIcon_1.default,
    chatBig: ChatBigIcon_1.default,
    chatSmall: ChatSmallIcon_1.default,
};
var ActionButtonIcon = function (_a) {
    var className = _a.className, icon = _a.icon;
    var Icon = ACTION_BUTTON_ICONS[icon];
    return (react_1.default.createElement("div", { className: action_button_icon_scss_includeInitial_1.default.container },
        react_1.default.createElement(inline_icon_1.default, { icon: Icon && react_1.default.createElement(Icon, null), className: classnames_1.default(action_button_icon_scss_includeInitial_1.default.icon, className) })));
};
exports.default = withStyles_1.withStyles(action_button_icon_scss_includeInitial_1.default)(ActionButtonIcon);
//# sourceMappingURL=action-button-icon.js.map